import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import { track } from "src/client/js/analytics/facade";

const trackLinkFactory =
  (config = {}) =>
  (event) => {
    if (isEmpty(config)) {
      return;
    }
    let { href } = config;
    if (!href && event.target) {
      href = event.target.closest("a")?.href;
    }
    if (isString(href) && href.startsWith("#")) {
      // ignore anchors
      href = null;
    }
    if (href) {
      event.preventDefault();
    }
    track(config.action, {
      category: config.category,
      label: config.label,
      value: config.value,
    }).then(() => {
      if (href) {
        window.top.location = href;
      }
    });
  };

export default trackLinkFactory;
